import React from "react";
import { Paper, Stack, Typography } from "@mui/material";
import type { LlmResponseRun, Summary } from "./types";

/**
 * Summary cards extraídas de CategoryReviewPage para mantener
 * la página ≤500L (P7). Sin cambio funcional vs versión inline.
 */

interface SummaryCardsProps {
  summary: Summary;
  llmResponses: LlmResponseRun[];
  onClickRecentExecutions: () => void;
}

export function SummaryCards({
  summary,
  llmResponses,
  onClickRecentExecutions,
}: SummaryCardsProps): React.ReactElement {
  return (
    <Stack direction="row" spacing={2} sx={{ flexWrap: "wrap", gap: 1 }}>
      <Paper sx={{ p: 1.5, minWidth: 130, textAlign: "center" }}>
        <Typography variant="caption" color="text.secondary">
          Total
        </Typography>
        <Typography variant="h6">
          {summary.totalProducts.toLocaleString()}
        </Typography>
      </Paper>
      <Paper
        sx={{
          p: 1.5,
          minWidth: 130,
          textAlign: "center",
          borderTop: "3px solid #4caf50",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          Clasificados
        </Typography>
        <Typography variant="h6" color="success.main">
          {summary.classified.toLocaleString()}
        </Typography>
      </Paper>
      <Paper
        sx={{
          p: 1.5,
          minWidth: 130,
          textAlign: "center",
          borderTop: "3px solid #ff9800",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          Sin clasificar
        </Typography>
        <Typography variant="h6" color="warning.main">
          {summary.unclassified.toLocaleString()}
        </Typography>
      </Paper>
      <Paper
        sx={{
          p: 1.5,
          minWidth: 130,
          textAlign: "center",
          borderTop: "3px solid #2196f3",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          Manuales
        </Typography>
        <Typography variant="h6" color="info.main">
          {summary.manualCorrections.toLocaleString()}
        </Typography>
      </Paper>
      <Paper sx={{ p: 1.5, minWidth: 130, textAlign: "center" }}>
        <Typography variant="caption" color="text.secondary">
          OpenAI
        </Typography>
        <Typography variant="h6">
          {(summary.bySource?.["openai"] || 0).toLocaleString()}
        </Typography>
      </Paper>
      {llmResponses.length > 0 && (
        <Paper
          sx={{
            p: 1.5,
            minWidth: 130,
            textAlign: "center",
            borderTop: "3px solid #9c27b0",
            cursor: "pointer",
            "&:hover": { bgcolor: "rgba(156, 39, 176, 0.04)" },
          }}
          onClick={onClickRecentExecutions}
        >
          <Typography variant="caption" color="text.secondary">
            Ejecuciones LLM
          </Typography>
          <Typography variant="h6" color="secondary.main">
            {llmResponses.length}
          </Typography>
        </Paper>
      )}
    </Stack>
  );
}
